export default __webpack_public_path__ + "static/media/earth_texture.6c0e8cf7.jpg";